__turbopack_context__.v({
  "promo-banner": "T_JoJW_promo-banner",
  "promo-banner-button": "T_JoJW_promo-banner-button",
  "promo-banner-text": "T_JoJW_promo-banner-text",
});
